import { useContent } from "@/context/ContentContext";

export const Servicios = () => {
  const { servicios: s } = useContent();

  return (
    <section className="sec dk" id="servicios" data-testid="servicios">
      <div className="wrap">
        <div className="split" style={{ alignItems: "end" }}>
          <div>
            <p className="lb" style={{ color: "var(--or)" }}>{s?.label}</p>
            <h2 className="h h2" style={{ marginTop: 20 }}>
              {s?.title} <span className="ac">{s?.title_accent}</span>
            </h2>
          </div>
          <p className="lead mut">{s?.intro}</p>
        </div>
        <div className="srv" style={{ marginTop: "clamp(48px,6vw,88px)" }}>
          {(s?.items || []).map((it, i) => (
            <a href="#contacto" key={i} data-testid={`servicio-${i}`}>
              <i>{it.num}</i>
              <h3 className="h h3">{it.title}</h3>
              <p className="p">{it.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
